<template>
  <div class="videosList">
    <top-header></top-header>

    <div class="collection-page--outer-wrapper marginBrandname" >

      <b-container >
		
		
		<b-row style="margin-top: 60px;">
			<b-col class="p-0">
        <div class="product-txt d-block text-center" style="padding:7px;text-transform:uppercase;box-shadow: 1px 3px #c6c6c6; background: #c6c6c630;font-size: 25px;">Properties</div>
		</b-col>
		</b-row>
			
		  <b-row> <!-- scrollBrand -->
					<b-col  cols="12" lg="3" md="3" sm="12" class="p-0  filterPael "  >
						<div  class="leftPanel  nav mobilfilter" id="filterlist" :class="[{'mobilfilterlist' : mobilfilterlist}]">
							<b-container fluid class="d-md-none applyPaneltop">
							  <b-row>
								<b-col cols="6" class="filtebrack">
								<b-link @click="mobilfilterlist=0"><i class="fa fa-angle-left"></i>
								<span>Filters</span></b-link>
								</b-col>
								<b-col class="applyBtn" cols="6">
									<b-link @click="mobilfilterlist=0" class="btnapply"></b-link>
								</b-col>
							   </b-row>
							   </b-container>
								<b-list-group flush class="scrollBrand scrollBrandHeight">
									<b-list-group-item style="padding:2px;"  v-if="filterCat==0">
											<b-list-group class="clgi">
											  <b-list-group-item href="#" @click="filter_catId='',filter_brandId='',getMyvideo()" active>Home</b-list-group-item>
											  <b-list-group-item href="#" @click="filter_catId=vcat.catId,filter_brandId='',getMyvideo()"  :key="vcat.catId" v-for="vcat in videoCategory" :class="{ activec : filter_catId == vcat.catId }"  >{{vcat.catName}}</b-list-group-item>
											  
											</b-list-group>
									</b-list-group-item>
									<b-list-group-item style="padding:2px;" v-if="filterBrand==0">
											<b-list-group class="clgi">
											  <b-list-group-item href="#" @click="filter_catId='',filter_brandId='',getMyvideo()" active>All Brands</b-list-group-item>
											  <b-list-group-item href="#" @click="filter_catId='',filter_brandId=brnd.brandId,getMyvideo()"  :key="brnd.brandId" v-for="brnd in brandList" :class="{ activec : filter_brandId == brnd.brandId }" >{{brnd.brand_name}} </b-list-group-item>
											  
											</b-list-group>
									</b-list-group-item>								  
								</b-list-group>
								
			
			
					
					</div>
					

				</b-col>
				
			<b-col cols="12" lg="9" md="9" sm="12"> 
		
			<div class="mb-4 mt-4 sPaelDiv" >
					
					<div ref="rpswiper" v-swiper:mySwiper="swiperOption" class="px-4">
						<div class="swiper-wrapper">
							<div  class="swiper-slide outline-secondary ml-2" @click="filter_catId='',filter_brandId='',getMyvideo()">
									All								
							</div>
							<b-button  class="swiper-slide outline-secondary" v-for="tCat in topCategory" @click="filter_catId=tCat.catId,filter_brandId='',getMyvideo()"  :key="tCat.catId">
									{{tCat.catName}}
							</b-button>
						</div>
						<div class="swiper-pagination" slot="pagination"></div>
						<div class="swiper-button-prev" slot="button-prev" @click="mySwiper.slidePrev()"></div>
						<div class="swiper-button-next" slot="button-next" @click="mySwiper.slideNext()"></div>
					</div>

				
			</div>
			
			
			<b-container fluid>
			<div class="all-products--wrapper d-flex flex-wrap justify-content-between"  >
			
				<!--https://stackoverflow.com/questions/69444144/how-to-capture-current-video-screen-or-thumbnail-with-vuejs -->
			
              <div v-for="product in videoList" :key="product.id" 
                class=" d-flex flex-column align-items-center pb-4 vldl" >  
					
					<b-link :href="'/properties/'+videoUrib64(product.id)">
							<!--<b-embed
							type="iframe"
							aspect="16by9"
							src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
							allowfullscreen
							></b-embed> -->
							<!-- {{product.id}}
							{{videoCanvas}} -->
							<!--<canvas :id="'image-canvas'+product.id" ref="imagecanvas" v-bind:width="width" v-bind:height="height" style="
								background-color: #c6c6c6;">
							</canvas> -->
							<video class="videodshList" :id="'videoPlaySource'+product.id" :src="$root.MEDIAPATH+'properties/'+product.video_url"></video>
							
							<!--<canvas id="canvas"></canvas> -->
							<h6 class="mb-1 mt-2 text-truncate">{{product.title}}</h6>							
								<p class="mb-1 p-0 text-truncate" style="line-height: initial;font-size:14px;">
								<!--<small class="text-truncate">{{product.message}}</small>-->
								<small>{{product.message}}</small>
								</p>
						
					</b-link>
					
					
              </div>
			  <div v-if="videoList.length%3>0" data-v-eedc78cc="" class=" d-flex flex-column align-items-center " style="width: 32%"> 
					</div>
					
					
			   <div v-if="videoList.length<1" style="width: 100%; margin-top:18%;">
				<div class="product--wrapperno d-flex flex-column align-items-center" >
                <span class="product-title d-block">No video available. Please check back later.</span>
				</div>
			  </div>
			  
			  <!--<div v-if="products.length%3>0" data-v-eedc78cc="" class=" d-flex flex-column align-items-center" style="width: 255px;">
				</div> -->
				
				<transition name="fade">
					<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
						<b-spinner label="Busy" variant="light"></b-spinner>
					</b-row>
				</transition>
            </div>
			
			</b-container>
			
			
		  
		  
		  
		  </b-col>
		  </b-row>
		  
			
		
      </b-container>
    </div>
			<!-- ------------ Filter Footer --------------- -->
		<b-container class="mt-2 d-md-none"></b-container>
		<!-- --------------------- -->
		
			<b-container fluid class="filterTab d-md-none">
				<b-row>
						<b-col 	cols="6" class="p-0 b-r-1px">
						<div class="segment-1">
						<b-link @click="filterCat=1,filterBrand=0,mobilfilterlist=1">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><filter id="565v74wosa" width="105.8%" height="143.8%" x="-2.9%" y="-21.9%" filterUnits="objectBoundingBox"><feOffset dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g fill="none" fill-rule="evenodd" opacity=".54"><g fill="#001325" fill-rule="nonzero"><g filter="url(#565v74wosa)" transform="translate(-207 -685) translate(0 672)"><g><g><g><path d="M18.533 5c.567 0 1.028.46 1.028 1.028 0 .247-.089.485-.25.672l-4.98 5.773v5.193c0 .332-.16.643-.43.836L11.9 19.935c-.462.33-1.104.224-1.435-.237-.125-.175-.192-.384-.192-.599v-6.625l-5.02-5.771c-.372-.429-.327-1.078.101-1.45C5.541 5.09 5.78 5 6.028 5h12.505zm-5.468 7.841h-1.528v5.797l1.528-1.094V12.84zm4.95-6.576H6.548l4.688 5.39h2.127l4.65-5.39z" transform="translate(195 6) translate(12) translate(0 7)"></path></g></g></g></g></g></g></svg>
								Brands </b-link>
							
							</div> 
						
						</b-col>
						<b-col cols="6" >
							<div class="segment2">
								<b-link @click="filterBrand=1,filterCat=0,mobilfilterlist=1">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><filter id="565v74wosa" width="105.8%" height="143.8%" x="-2.9%" y="-21.9%" filterUnits="objectBoundingBox"><feOffset dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g fill="none" fill-rule="evenodd" opacity=".54"><g fill="#001325" fill-rule="nonzero"><g filter="url(#565v74wosa)" transform="translate(-207 -685) translate(0 672)"><g><g><g><path d="M18.533 5c.567 0 1.028.46 1.028 1.028 0 .247-.089.485-.25.672l-4.98 5.773v5.193c0 .332-.16.643-.43.836L11.9 19.935c-.462.33-1.104.224-1.435-.237-.125-.175-.192-.384-.192-.599v-6.625l-5.02-5.771c-.372-.429-.327-1.078.101-1.45C5.541 5.09 5.78 5 6.028 5h12.505zm-5.468 7.841h-1.528v5.797l1.528-1.094V12.84zm4.95-6.576H6.548l4.688 5.39h2.127l4.65-5.39z" transform="translate(195 6) translate(12) translate(0 7)"></path></g></g></g></g></g></g></svg>
								Categories </b-link>
								
								</div>
						</b-col>
				</b-row>
				</b-container>


    <!--<top-footer></top-footer>  -->
  </div>
</template>

<script>
import Header from "@/components/header.vue";
//import Footer from "@/components/footer.vue";


//import '../assets/category.scss';
//import RangeSlider from 'vue-range-slider';
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css';
import '@/assets/videos.scss';
const widthN = window.innerWidth;
const heightN = window.innerHeight;
export default {
  name: "collection-page-cosmetics",
  
	props: {
    WEBURL: { type: String },
		metadata: { type: Object },
	},
	
	beforeCreate: function () {
    document.body.className = "collection-page-cosmetics";
  },
  components: {
    "top-header": Header,
    //"top-footer": Footer,
    
    //RangeSlider,
  },
  computed: {
		videoCanvas: function () {
		  // `this` points to the vm instance
		  return 'sdfsdf';
		},
		/*canvas:function () {
				console.log('sdsd'+this.id);
			return this.$refs.imagecanvas;
		},
		ctx: function () {
			return this.canvas.getContext('2d');
		},*/
		imageConfig() {
		  return {
			image: this.video,
			x: 0,
			y: 0,
			width: 320,
			height: 180
		  };
		}
	},
  mounted(){
		this.initload();
		
	  /* ============Sticky LeftPanel===============*/
	  this.$nextTick(function(){
        window.addEventListener("scroll", function(){
          var navbar = document.getElementById("filterlist")
          var nav_classes = navbar.classList
          if(document.documentElement.scrollTop >= 150) {
            if (nav_classes.contains("shrink") === false) {
              nav_classes.toggle("shrink");
            }
			
          }
          else {
            if (nav_classes.contains("shrink") === true) {
              nav_classes.toggle("shrink");
            }
          }
        })
      })
	
		
		
	},
  data() {
    return {
		
		loading: false,
		mobilfilterlist:0,
		stageSize: {
		width: widthN,
		height: heightN
		},
		video: undefined,
		animation: undefined,
		videoListUrl: this.$root.WEBAPI+'propertieapi/video-list',
		videoList: [],
		videoCategory: [],
		topCategory: [],
		brandList:[],
		filter_catId:'',
		filter_brandId:'',
		filterBrand:0,
		filterCat:0,
		
		height: 120,
		width: 220,
		margin: 20,
			swiperOption: {
				direction: 'horizontal',
				initialSlide: 0,
				slidesPerGroup: 2,
				loop: false,
				watchSlidesVisibility: true,
				/*preloadImages: false,
				lazy: true,*/
				loopFillGroupWithBlank: true,
				breakpoints: {
					320: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					// when window width is >= 480px
					480: {
						slidesPerView: 3,
						spaceBetween: 30
					},
					// when window width is >= 640px
					640: {
						slidesPerView: 4,
						spaceBetween: 30
					},
					// when window width is >= 640px
					960: {
						slidesPerView: 5,
						spaceBetween: 30
					},
					// when window width is >= 640px
					1124: {
						slidesPerView: 9,
						spaceBetween: 10
					}
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				on: {
					init: function () {
						console.log('swiper initialized');
					},
					slideChange: function() {
						console.log('slide changed');
					}
				},
				fadeEffect: {
					crossFade: true
				},
			}

		
    };
  },
  methods: {
	initload(){
		var self = this;
		self.axios.post(self.videoListUrl, {
				catId: 	 self.filter_catId,
				brandId: self.filter_brandId,
				loadVideo:'',
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                //console.log(response.data);
                  self.videoList = response.data.result.videoList;
                  self.videoCategory = response.data.result.videoCategory;
                  self.topCategory = response.data.result.topCategory;
                  self.brandList = response.data.result.brandList;
                  
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          });
	
	},
	getMyvideo(){
		var self = this;
		
		self.mobilfilterlist=0;
		self.loading= true;
		self.videoList =[];
		self.axios.post(self.videoListUrl, {
				catId: self.filter_catId,
				brandId: self.filter_brandId,
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                //console.log(response.data);
                  self.videoList = response.data.result.videoList;
                  self.videoCategory = response.data.result.videoCategory;
                  
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
			  self.loading= false;
          }).catch(function (error) {
              alert(error);
          });
	
	},
	videoUrib64(idm) {
			//console.log(idm);
			return btoa(idm);
	}
  },
  metaInfo() {
        //console.log('-------META INFO-------');
		/*return{
			title: this.metadata.title,
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: this.metadata.keywords },
				{ name: 'description', content: this.metadata.description },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }

			]
		}*/
	}
};
</script>

<style scoped lang="scss">

	
</style>